import * as yup from 'yup';

export const vermietungsObjektSchema = yup
  .number()
  .min(1)
  .max(100000)
  .default(undefined);
